import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ModalContainer, ModalButton, ModalClose, ModalSecondaryHeader, ModalCopy } from 'shared/modals';
import { openZendeskWidget } from 'shared/helpers/tools';
export default function(props) {
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        isOpen: true,
        onRequestClose: props.onRequestClose,
        children: [
            /*#__PURE__*/ _jsx(ModalSecondaryHeader, {
                children: "OOPS!"
            }),
            /*#__PURE__*/ _jsx(ModalCopy, {
                maxWidth: 350,
                children: props.message
            }),
            /*#__PURE__*/ _jsx(ModalButton, {
                onClick: function() {
                    openZendeskWidget();
                    props.onRequestClose();
                },
                children: "Contact dutchie"
            }),
            /*#__PURE__*/ _jsx(ModalClose, {
                onClick: props.onRequestClose
            })
        ]
    });
};
